module.exports = __webpack_public_path__ + "img/5293857.png";